import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DeviceContextInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Normaliza URLs com possíveis barras duplas acidentais (mantendo https://)
    const cleanedUrl = request.url.replace(/([^:]\/)\/+/g, '$1');

    // Injeta o header de contexto seguro do dispositivo
    const secureReq = request.clone({
      url: cleanedUrl,
      headers: request.headers.set('X-Device-Context', 'asap_authorized_access')
    });

    return next.handle(secureReq);
  }
}



// WEBPACK FOOTER //
// ./src/app/@core/interceptors/device-context.interceptor.ts